(() => {
  const money = (cents) => {
    const value = (Number(cents || 0) / 100).toFixed(2);
    return `${window.Shopify?.currency?.active || '$'}${value}`;
  };

  const initGallery = (gallery) => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const track = gallery.querySelector('[data-gallery-track]');
    if (!slides.length || !track) return;
    let activeIndex = 0;
    let scrollFrame;
    const setActive = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === activeIndex));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === activeIndex));
    };
    const select = (index) => {
      setActive(index);
      track.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        if (track.clientWidth) setActive(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); select(activeIndex + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); select(activeIndex - 1); }
    });
  };

  const initProduct = (section) => {
    const json = section.querySelector('[data-product-json]');
    if (!json) return;
    let product;
    try { product = JSON.parse(json.textContent); } catch (_) { return; }
    const form = section.querySelector('[data-product-form]');
    const idInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const addButton = section.querySelector('[data-add-button]');
    const choices = [...section.querySelectorAll('[data-option-index]')];

    const updateVariant = () => {
      const selected = [];
      const positions = [...new Set(choices.map((choice) => Number(choice.dataset.optionIndex)))];
      positions.forEach((position) => {
        const selectedInput = choices.find((choice) => Number(choice.dataset.optionIndex) === position && choice.checked);
        selected[position] = selectedInput?.value;
      });
      const variant = product.variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.querySelector('[data-add-text]').textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    choices.forEach((choice) => choice.addEventListener('change', updateVariant));
    updateVariant();

    const subscription = section.querySelector('[data-subscription-radio]');
    const oneTime = section.querySelector('[data-one-time-radio]');
    const sellingPlan = section.querySelector('[data-selling-plan]');
    const toggleSellingPlan = () => {
      if (!sellingPlan) return;
      const enabled = Boolean(subscription?.checked);
      sellingPlan.disabled = !enabled;
      if (!enabled) sellingPlan.value = '';
    };
    subscription?.addEventListener('change', toggleSellingPlan);
    oneTime?.addEventListener('change', toggleSellingPlan);
    toggleSellingPlan();

    form?.addEventListener('submit', () => {
      if (addButton) addButton.setAttribute('aria-busy', 'true');
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
  });
})();
